/**
 * The Zxing camera scanner library is very large.  This will lazy load it.
 */
import { lazy, createElement as rc, Suspense } from 'react';
import Text from '../Text';

// This allows the barcode dependencies to be loaded lazily, which in turn allows webpack
// to put them in a separate chunk.  This helps initial page load time because these big
// dependencies don't have to be loaded until they are needed.
export default function BarcodeScannerProxy(props) {
    // avoid warning for dynamic import (which seems to need the extension)
    // eslint-disable-next-line import/extensions
    const BarcodeScanner = lazy(() => import('./BarcodeScannerInner/index.js'));
    const fallback = rc(Text, null, 'Loading...');
    // prettier-ignore
    return rc(Suspense, {fallback},
        rc(BarcodeScanner, props)
    );
}
